import { routes as auth } from './auth'

import { routes as businessArea } from './businessArea'
import { routes as systems } from './systems'
import { routes as modules } from './modules'
import { routes as module } from './module'
import { routes as user } from './user'

export default [
  ...auth,

  ...businessArea,
  ...systems,
  ...modules,
  ...module,
  ...user
]



// WEBPACK FOOTER //
// ./src/app/routes.js